function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path fill="#fff" d="M21.85 0v9.415h10.275v13.211H21.85V32L-.009 16zm7.339 12.351H18.914V5.79L4.96 16.001l13.954 10.214V19.69h10.275v-7.339z" /></svg>;
});